import { Routes, Route } from "react-router-dom";
import ReviewList from "./index";
import ReviewDetail from "../questions/ReviewQuestions/ReviewDetail";

const ReviewsRouter = () => {
  return (
    <Routes>
      <Route index element={<ReviewList />} />
      <Route path=":id" element={<ReviewDetail />} />
    </Routes>
  );
};

export default ReviewsRouter;
